module.exports = "/assets/images/6681d2677461b10a30bc87f354415382.png";